import React, { Component } from 'react';
import { Link } from 'react-scroll'
import Mailto from 'react-mailto.js';
import Fade from 'react-reveal/Fade';

// Constants
const today = new Date();

class Footer extends Component {
  render() {
    return (
      <footer>

        <Fade right cascade>
        <nav>
          <ul>
            <li>
              <Link to="video" spy={true} smooth={true}>Why Whofolio</Link>
            </li>
            <li>
              <Link to="join" spy={true} smooth={true}>Join the Team</Link>
            </li>
            <li>
              <Mailto
                secure={true}
                to='info@whofolio.com'
                subject="Question from the website">
                Answers
              </Mailto>
            </li>
            <li>
              <Mailto
                secure={true}
                to='info@whofolio.com'
                subject="Contact from the website">
                Contact
              </Mailto>
            </li>
            <li>
              <Link to="signUp" spy={true} smooth={true}>Early Access</Link>
            </li>
          </ul>
        </nav>
        </Fade>

        <div className="copyright">
          <span>Copyright &copy; Whofolio {today.getFullYear()}. All rights reserved.</span>
        </div>

      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/assets/components/footer.js